import update from "immutability-helper";

import {
  MESSAGES_LOADING_START,
  MESSAGES_LOADING_SUCCESS,
  MESSAGES_LOADING_FAILED,
  CHANGE_MESSAGES_PAGE,
  CHANGE_MESSAGES_LIMIT,
  SWITCH_MESSAGES_FILTER,
} from '../actions/messagesList';

import { SIGN_OUT } from '../actions/auth';

const INITIAL_STATE = {
  ready: false,
  loading: false,
  messages: [],
  total: 0,
  limit: 15,
  activePage: 1,
  filters: {
    client: false,
    consultant: false,
    any: false,
  }
};

export default function (state = INITIAL_STATE, action) { 
  switch (action.type) {
    case MESSAGES_LOADING_START:
      return {
        ...state,
        ready: false,
        loading: true,
        messages: [],
        total: 0,
      };
    case MESSAGES_LOADING_SUCCESS:
      return {
        ...state,
        ready: true,
        loading: false,
        messages: action.payload.messages.messages,
        total: parseInt(action.payload.messages.count, 10),
      };
    case MESSAGES_LOADING_FAILED:
      return {
        ...state,
        ready: false,
        loading: false,
      };
    //Пагинация
    case CHANGE_MESSAGES_PAGE:
      return {
        ...state,
        activePage: action.payload.activePage,
      };
    case CHANGE_MESSAGES_LIMIT:
      return {
        ...state,
        limit: action.payload.activeLimit,
        activePage: INITIAL_STATE.activePage,
      };
    //Фильтры
    case SWITCH_MESSAGES_FILTER:
      return update(state, {
        filters: {
          [action.payload.filter]: {$set: !state.filters[action.payload.filter]},
        }
      });
    case SIGN_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}